import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

export const api = axios.create({
  baseURL: API,
  timeout: 180000,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("rp_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// resolve /api/media/{id} paths to absolute URLs
export const mediaUrl = (relOrId) => {
  if (!relOrId) return "";
  if (/^https?:\/\//.test(relOrId)) return relOrId;
  if (relOrId.startsWith("/api/")) return `${BACKEND_URL}${relOrId}`;
  return `${API}/media/${relOrId}`;
};

export const platformStyle = {
  Netflix: "bg-black text-white",
  "Disney+": "bg-[#0a1c4a] text-white",
  "Prime Video": "bg-[#00A8E1] text-white",
  "Apple TV+": "bg-neutral-900 text-white",
  "Canal+": "bg-neutral-800 text-white",
  // Max (ex HBO Max) — bleu profond signature, cohérent avec l'identité de marque.
  Max: "bg-[#002be7] text-white",
  // Arte — noir + accent typographique. Sobre, éditorial, dans la ligne du site.
  Arte: "bg-[#111111] text-white border border-white/10",
  "En salle": "bg-[var(--red)] text-white",
  "À venir": "bg-neutral-100 text-neutral-700 border border-neutral-200",
};

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function fmtDateShort(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "short",
    });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function releaseId(r) {
  return `${r.type}:${r.tmdb_id}`;
}

// Normalises the platform labels displayed on a release card. TMDB flags
// films with an unresolved streaming home as `["À venir"]`, which is
// misleading once the film is already out in theatres — the visitor
// naturally reads it as "not yet released". We swap that placeholder
// for "En salle" when the film's release_date is in the past.
export function displayPlatforms(r) {
  const today = new Date().toISOString().slice(0, 10);
  const isReleased = !!(r?.release_date && r.release_date <= today);
  const raw = Array.isArray(r?.platforms) ? r.platforms : [];
  return raw.map((p) =>
    r?.type === "Film" && isReleased && p === "À venir" ? "En salle" : p
  );
}

// Label displayed above the title of an article teaser card. Adapts to
// the article's primary content type so a piece featuring a video shows
// "À voir" (invites playback) whereas a text-only piece shows "À lire".
// The admin can override this via `teaser_label` on the article.
export function articleLabel(a) {
  const manual = a?.teaser_label;
  if (manual === "read") return "À lire";
  if (manual === "watch") return "À voir";
  const hasVideo = Array.isArray(a?.blocks) && a.blocks.some((b) => b?.type === "video");
  return hasVideo ? "À voir" : "À lire";
}
